import { Button, Grid, Typography } from '@material-ui/core';
import React from 'react';

import { INetworkChannel, NetworkChannelField } from '~/src/dash/api/network';
import { NetworkInventorySplit } from '~/src/dash/components/network-inventory-split';
import { IWizardStepProps } from '~/src/dash/components/wizard';
import WizardButtons from '~/src/dash/components/wizard-buttons';

/**
 * All these props are state variables passed from
 * the parent component (network-settings-view)
 */
interface IInventorySplitFormProps extends IWizardStepProps {
  // Helper
  isNewOrClone: boolean;
  isSuper: () => boolean;
  canEdit: () => boolean;
  isUserInfoMasked: () => boolean;

  isUpdating: boolean;
  saveAttempted: boolean;

  NetworkChannels: INetworkChannel[];
  handleCreateNewNetworkChannel: () => void;
  handleDeleteNetworkChannel: (idx: number) => void;
  validateNetworkChannel: (channel: INetworkChannel) => string[];
  handleChangeNetworkChannel: (idx: number, field: NetworkChannelField, value: any) => void;
}

const InventorySplitForm = ({
  onNext,
  onBack,
  isSuper,
  canEdit,
  isUserInfoMasked,
  NetworkChannels: Channels,
  isUpdating,
  isNewOrClone,
  validateNetworkChannel: validateChannel,
  handleCreateNewNetworkChannel: handleCreateNewChannel,
  handleDeleteNetworkChannel,
  handleChangeNetworkChannel,
}: IInventorySplitFormProps) => {
  const [saveAttempted, setSaveAttempted] = React.useState(false);

  let hasError = false;
  for (const channel of Channels) {
    if (validateChannel(channel).length > 0) {
      hasError = true;
    }
  }

  return (
    <>
      <Typography
        style={{
          paddingLeft: '5px',
          marginTop: '0px',
          marginBottom: '1px',
          fontSize: '16px',
          fontWeight: 600,
        }}
      >
        <span>Who gets to monetize your inventory?</span> Set which demand stack to call to retrieve
        ads
      </Typography>
      <Typography
        style={{
          fontSize: '14px',
          paddingLeft: '5px',
          marginTop: '0px',
          marginBottom: '1.5rem',
          color: '#757575',
        }}
      >
        Requests will be split to destinations using the allocation % set below.
      </Typography>

      <RenderSplitRoutes
        isSuper={isSuper}
        canEdit={canEdit}
        isNewOrClone={isNewOrClone}
        isUpdating={isUpdating}
        saveAttempted={saveAttempted}
        isUserInfoMasked={isUserInfoMasked}
        NetworkChannels={Channels}
        handleCreateNewNetworkChannel={handleCreateNewChannel}
        handleDeleteNetworkChannel={handleDeleteNetworkChannel}
        validateNetworkChannel={validateChannel}
        handleChangeNetworkChannel={handleChangeNetworkChannel}
      />

      <WizardButtons
        onNext={() => {
          if (!hasError && onNext) {
            onNext();
          }
          setSaveAttempted(true);
        }}
        onBack={onBack}
      />
    </>
  );
};

export const RenderSplitRoutes = ({
  NetworkChannels: Channels,
  canEdit,
  isSuper,
  isNewOrClone,
  isUserInfoMasked,
  handleDeleteNetworkChannel,
  handleChangeNetworkChannel,
  validateNetworkChannel: validateChannel,
  saveAttempted,
  handleCreateNewNetworkChannel: handleCreateNewChannel,
  isUpdating,
}: IInventorySplitFormProps) => {
  const totalWeight = Channels.reduce((ret: number, c: INetworkChannel) => {
    return (c.Weight ? c.Weight : 0) + ret;
  }, 0);

  return (
    <>
      {Channels.map((channel: INetworkChannel, index: number) => {
        return (
          <Grid
            item
            style={{
              marginTop: index === 0 ? '0px' : '1rem',
            }}
          >
            <NetworkInventorySplit
              canEdit={canEdit()}
              isUserInfoMasked={isUserInfoMasked()}
              ID={channel.ID}
              isNewOrClone={isNewOrClone}
              SiteID={channel.SiteID ? channel.SiteID : 0}
              RouteID={channel.RouteID ? channel.RouteID : 0}
              Name={channel.Name}
              Weight={channel.Weight}
              DemandSourceType={channel.DemandSourceType}
              AdURL={channel.AdURL}
              AppBundleOverride={channel.AppBundleOverride}
              index={index}
              totalWeight={totalWeight}
              handleDeleteNetworkChannel={handleDeleteNetworkChannel}
              handleChangeNetworkChannel={handleChangeNetworkChannel}
              validateNetworkChannel={validateChannel}
              saveAttempted={saveAttempted}
            />
          </Grid>
        );
      })}

      {(isSuper() || canEdit()) && (
        <Button
          onClick={handleCreateNewChannel}
          disabled={isUpdating}
          style={{
            marginTop: '15px',
          }}
        >
          <Typography
            style={{
              color: '#5c6bf8',
              fontSize: '16px',
              fontWeight: 500,
              textTransform: 'none',
            }}
          >
            + Add Destination
          </Typography>
        </Button>
      )}
    </>
  );
};

export default InventorySplitForm;
